/**
 * UnauthorizedError — 401 Unauthorized responses
 * 
 * Thrown when the server rejects the request due to missing,
 * expired, or invalid authentication credentials.
 * Supports inner-error chaining for root-cause tracking.
 */
export class UnauthorizedError extends Error {
    constructor(
        public readonly message: string = 'Unauthorized request.',
        public readonly innerError?: Error
    ) {
        super(message);
        this.name = 'UnauthorizedError';
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }

    public toString(): string {
        return `UnauthorizedError: ${this.message}`;
    }
}
